// ====================================================
// src/components/block/liveStreamManagement/audioEffects/registry.ts
//
// Un seul point d'inscription : pour ajouter un effet audio au panneau, créer sa
// classe (cf. LowcutEffect.tsx / ReverbEffect.tsx pour le modèle) et l'ajouter ici.
// SourceConfigModal et useAudioMetering ne bouclent que sur ce tableau.
// ====================================================

import { AudioEffect } from './AudioEffect';
import { lowcutEffect } from './LowcutEffect';
import { reverbEffect } from './ReverbEffect';
import { compressorEffect } from './CompressorEffect';
import { noisegateEffect } from './NoisegateEffect';
import { pitchEffect } from './PitchEffect';
import { echoEffect } from './EchoEffect';
import { robotEffect } from './RobotEffect';
import { chorusEffect } from './ChorusEffect';
import { equalizerEffect } from './EqualizerEffect';

export const AUDIO_EFFECTS: AudioEffect<any>[] = [
  lowcutEffect,
  compressorEffect,
  noisegateEffect,
  reverbEffect,
  pitchEffect,
  echoEffect,
  robotEffect,
  chorusEffect,
  equalizerEffect,
];
